import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const ProposalsPage = lazy(() => import('../pages/proposals/page'));
const ProposalDetailPage = lazy(() => import('../pages/proposals/detail/page'));
const ProposalEditPage = lazy(() => import('../pages/proposals/edit/page'));
const ProposalNewPage = lazy(() => import('../pages/proposals/new/page'));
const ProposalOverviewPage = lazy(() => import('../pages/proposal-overview/page'));
const CustomersPage = lazy(() => import('../pages/customers/page'));
const CustomerDetailPage = lazy(() => import('../pages/customers/detail/page'));
const CustomerEditPage = lazy(() => import('../pages/customers/edit/page'));
const CustomerNewPage = lazy(() => import('../pages/customers/new/page'));
const VendorsPage = lazy(() => import('../pages/vendors/page'));
const VendorDetailPage = lazy(() => import('../pages/vendors/detail/page'));
const VendorEditPage = lazy(() => import('../pages/vendors/edit/page'));
const VendorNewPage = lazy(() => import('../pages/vendors/new/page'));
const UsersPage = lazy(() => import('../pages/users/page'));
const SettingsPage = lazy(() => import('../pages/settings/page'));
const CalendarPage = lazy(() => import('../pages/calendar/page'));
const PastEventsPage = lazy(() => import('../pages/past-events/page'));
const ReportsPage = lazy(() => import('../pages/reports/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const RFQPage = lazy(() => import('../pages/rfq/page'));
const NewRFQPage = lazy(() => import('../pages/rfq/new/page'));
const RFQDetailPage = lazy(() => import('../pages/rfq/detail/page'));
const EditRFQPage = lazy(() => import('../pages/rfq/edit/page'));
const ContractsPage = lazy(() => import('../pages/contracts/page'));
const NewContractPage = lazy(() => import('../pages/contracts/new/page'));
const ContractDetailPage = lazy(() => import('../pages/contracts/detail/page'));
const EditContractPage = lazy(() => import('../pages/contracts/edit/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/dashboard',
    element: <DashboardPage />,
  },
  {
    path: '/proposals',
    element: <ProposalsPage />,
  },
  {
    path: '/proposals/detail/:id',
    element: <ProposalDetailPage />,
  },
  {
    path: '/proposals/:id',
    element: <ProposalDetailPage />,
  },
  {
    path: '/proposals/:id/edit',
    element: <ProposalEditPage />,
  },
  {
    path: '/proposals/edit/:id',
    element: <ProposalEditPage />,
  },
  {
    path: '/proposals/new',
    element: <ProposalNewPage />,
  },
  {
    path: '/proposal-overview',
    element: <ProposalOverviewPage />
  },
  {
    path: '/customers',
    element: <CustomersPage />,
  },
  {
    path: '/customers/new',
    element: <CustomerNewPage />,
  },
  {
    path: '/customers/:id',
    element: <CustomerDetailPage />,
  },
  {
    path: '/customers/detail/:id',
    element: <CustomerDetailPage />,
  },
  {
    path: '/customers/:id/edit',
    element: <CustomerEditPage />,
  },
  {
    path: '/vendors',
    element: <VendorsPage />,
  },
  {
    path: '/vendors/:id',
    element: <VendorDetailPage />,
  },
  {
    path: '/vendors/detail/:id',
    element: <VendorDetailPage />,
  },
  {
    path: '/vendors/:id/edit',
    element: <VendorEditPage />,
  },
  {
    path: '/vendors/new',
    element: <VendorNewPage />,
  },
  {
    path: '/users',
    element: <UsersPage />,
  },
  {
    path: '/settings',
    element: <SettingsPage />,
  },
  {
    path: '/calendar',
    element: <CalendarPage />,
  },
  {
    path: '/past-events',
    element: <PastEventsPage />,
  },
  {
    path: '/reports',
    element: <ReportsPage />,
  },
  {
    path: '/rfq',
    element: <RFQPage />,
  },
  {
    path: '/rfq/new',
    element: <NewRFQPage />,
  },
  {
    path: '/rfq/detail/:id',
    element: <RFQDetailPage />,
  },
  {
    path: '/rfq/edit/:id',
    element: <EditRFQPage />,
  },
  {
    path: '/rfq/:id/edit',
    element: <EditRFQPage />,
  },
  {
    path: '/contracts',
    element: <ContractsPage />,
  },
  {
    path: '/contracts/new',
    element: <NewContractPage />,
  },
  {
    path: '/contracts/:id',
    element: <ContractDetailPage />,
  },
  {
    path: '/contracts/detail/:id',
    element: <ContractDetailPage />,
  },
  {
    path: '/contracts/:id/edit',
    element: <EditContractPage />,
  },
  {
    path: '/contracts/edit/:id',
    element: <EditContractPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
